import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=4432b3c7&scoped=true&"
import script from "./SectionCard.vue?vue&type=script&lang=js&"
export * from "./SectionCard.vue?vue&type=script&lang=js&"
import style0 from "./SectionCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SectionCard.vue?vue&type=style&index=1&id=4432b3c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4432b3c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBadge,VCard,VCheckbox})
